import { Device, L1Category, PageType } from '@gumtree/shared/src/types/client-data';

type AdProvider = 'adsense' | 'bing';

export const canShowTextAds = (
    pageType: PageType | undefined,
    l1Category: L1Category | undefined
) => {
    return (
        (pageType === 'ResultsBrowse' || pageType === 'ResultsSearch') &&
        (l1Category === 'for-sale' || l1Category === 'toplevel')
    );
};

export type TextAdConditions = {
    pageType: PageType | undefined;
    l1Category: L1Category | undefined;
    device: Device | undefined;
    currentPage: number | undefined;
    adExperimentVariants?: string[][];
    resultSize?: number;
};

export const whichTextAdType = ({
    pageType,
    l1Category,
    currentPage,
}: Partial<TextAdConditions>): 'ADSENSE' | 'BING' | undefined => {
    if (canShowTextAds(pageType, l1Category) && typeof currentPage === 'number') {
        return 'BING';
    }

    return undefined;
};

export const createTracking = ({
    pageType,
    l1Category,
    currentPage,
    device,
    adExperimentVariants,
    isZeroResults,
    adProvider,
}: TextAdConditions & {
    isZeroResults: boolean;
    adProvider: AdProvider;
}) => {
    const trackingPageType =
        pageType === 'ResultsBrowse'
            ? `${isZeroResults ? 'Z' : ''}BRP`
            : pageType === 'ResultsSearch'
            ? `${isZeroResults ? 'Z' : ''}SRP`
            : 'unknown-page-type';

    const trackingDevice =
        device === 'mobile'
            ? 'mobile'
            : device && ['tablet', 'desktop'].includes(device)
            ? 'desktop'
            : 'unknown-device';

    const experiments = adExperimentVariants
        ?.map(([experimentId, value]) => `${experimentId}-${value}`)
        .join('_');
    const trackingPageNumber =
        currentPage && Number.isInteger(currentPage) && currentPage > 1
            ? 'page2'
            : currentPage === 1
            ? 'page1'
            : 'page-invalid';

    if (adProvider === 'adsense') {
        return `web_${trackingDevice}_${trackingPageType}_${l1Category}${experiments ? `_${experiments}` : ''}`;
    } else {
        return `web_${trackingDevice}_${trackingPageType}_${l1Category}_${trackingPageNumber}${
            experiments ? `_${experiments}` : ''
        }`;
    }
};
